export const getHotelMealType = (mealPlan?: string) => {
  const normalized = (mealPlan || '').trim().toLowerCase();
  if (!normalized) return '';
  if (normalized.includes('breakfast')) return 'Breakfast_For_2';
  if (normalized.includes('half board') || normalized.includes('full board') || normalized.includes('all inclusive')) {
    return 'All_Inclusive_All_Meal';
  }
  return '';
};
